import React from "react";
import Readme from "./Readme";
import PageComponent from "../PageComponent";
import raw from "raw.macro";
import { labels } from "../../../../localization/labels";

class ReadmeContainer extends PageComponent {
  constructor(props) {
    super(props);
    this.state = { markdown: raw("../../../../../README.md") };
  }

  getComponentTitle = () => {
    return labels.information;
  };

  render() {
    return <Readme source={this.state.markdown} />;
  }
}

export default ReadmeContainer;
